export const EVENT_TRACKER_APP_NAME = 'ixlab';

export const EventTrackerEvents = {
    PatientRegistration: 'PATIENT_REGISTRATION',
    Navigation: 'NAVIGATION',
} as const;

export const EVENT_TRACKER_EVENTS = Object.values(EventTrackerEvents);

export const EventTrackerEventStatuses = {
    Init: 'INIT',
    Success: 'SUCCESS',
    Error: 'ERROR',
} as const;

export const EVENT_TRACKER_EVENT_STATUSES = Object.values(EventTrackerEventStatuses);
